import { IComboboxSelectedChangeEventArgs } from '../../../BCCombobox';
import BCRadioButtonGroup from '../../../BCRadioButtonGroup';
import { IPropertyComponentProps } from '../../entities';

export default function RadioProperty(props: IPropertyComponentProps) {
	const onSelectedChange = (args: IComboboxSelectedChangeEventArgs) => {
		if (props.customChangeEvent) {
			return props.customChangeEvent(args);
		}

		props.onValueChanged(props.item, args.data);
	};

	return (
		<BCRadioButtonGroup
			disabled={props.item.disabled || props.item.readOnly}
			onChange={onSelectedChange}
			options={props.item.options}
			readOnly={props.readonly}
			value={props.value}
			style={props.style}
			mode="horizontal"
		/>
	);
}
